import {
    type GetParticipantActiveStateResponseType,
    type GetParticipantActiveStateRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetParticipantActiveState = async (params: GetParticipantActiveStateRequestType): Promise<GetParticipantActiveStateResponseType> => {
    return await axios(`${SERVER_ADDRESS}/threeT/getParticipantActiveState`, {
        method: "GET",
        headers: getHeaders(),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetParticipantActiveState;
